import { decisionCardResolution } from '@lc/const/turnTypes';
import { controller_card } from '@lc/controller/card';
import { controller_game } from '@lc/controller/game';
import { GameManager } from '@lc/interface/gameManager/types';
import { Player } from '@lc/interface/player/types';
import { createBotPlayerData } from '@lc/lib/ai_helper';
import { coinFlip } from '@lc/lib/gamestate_helper';
import { getPlayerStateWithId } from '@lc/lib/player_helper';
import {
	calculateBatteryCost,
	calculateFactoryCost,
} from '@lc/lib/playermat_helper';

import { ai_decision } from './ai_decision';
import { ai_purchase } from './ai_purchase';

class AI_Seasonal {
	// If total energy is enough, buy a battery
	buyBattery = async (gameManager: GameManager) => {
		const { gameState } = gameManager;

		const activePlayerId = gameState.activePlayerId;

		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const batteryCost = calculateBatteryCost(aiState);

		const paymentObject = await ai_purchase.createPaymentObjectForCost(
			aiState,
			batteryCost
		);

		if (paymentObject.paymentPossible) {
			console.log('bot purchase paymentObject');
			console.log(paymentObject);

			console.log('AI with id ' + activePlayerId + ' buying battery:');

			const botPlayerData = {
				playerId: gameState.activePlayerId,
				gameId: gameState.game_id_server,
				paymentObject,
			};

			await controller_game.buyBattery(botPlayerData, gameManager);
		}
	};

	// If total energy is enough, buy a factory
	buyFactory = async (gameManager: GameManager) => {
		const { gameState } = gameManager;

		const activePlayerId = gameState.activePlayerId;

		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const factoryCost = calculateFactoryCost(aiState);

		const paymentObject = await ai_purchase.createPaymentObjectForCost(
			aiState,
			factoryCost
		);

		if (paymentObject.paymentPossible) {
			console.log('bot purchase paymentObject');
			console.log(paymentObject);

			console.log('AI with id ' + activePlayerId + ' buying factory:');

			const botPlayerData = {
				playerId: gameState.activePlayerId,
				gameId: gameState.game_id_server,
				paymentObject,
			};

			await controller_game.buyFactory(botPlayerData, gameManager);
		}
	};

	// If total energy is enough, buy PR
	buyPR = async (gameManager: GameManager) => {
		const { gameState } = gameManager;

		const activePlayerId = gameState.activePlayerId;

		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const prCost = 2;

		const paymentObject = await ai_purchase.createPaymentObjectForCost(
			aiState,
			prCost
		);

		if (paymentObject.paymentPossible) {
			console.log('bot purchase paymentObject');
			console.log(paymentObject);

			console.log('AI with id ' + activePlayerId + ' buying PR:');

			const botPlayerData = {
				playerId: gameState.activePlayerId,
				gameId: gameState.game_id_server,
				paymentObject,
			};

			await controller_game.buyPR(botPlayerData, gameManager);
		}
	};

	donation = async (gameManager: GameManager) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		// donate all remaining energy (first round buy battery, second round factory?)

		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const paymentObject = {
			factoryEnergyArr: [...aiState.factoryEnergyArr],
			batteryEnergyArr: [...aiState.batteryEnergyArr],
			carbonReserve: 0,
		};

		console.log('AI with id ' + activePlayerId + ' donating:');

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			paymentObject,
		};

		await controller_game.donateEnergy(botPlayerData, gameManager);
	};

	async storeEnergy(gameManager: GameManager) {
		const botPlayerData = createBotPlayerData(gameManager);

		await controller_game.storeEnergy(botPlayerData, gameManager);
	}

	async stealCarbon(gameManager: GameManager) {
		const botPlayerData = createBotPlayerData(gameManager);

		await controller_game.stealCarbon(botPlayerData, gameManager);
	}

	async deleteCardChance(aiState: Player, cardId: number) {
		if (aiState.seasonalCards.includes(cardId)) {
			if (coinFlip()) {
				console.log(
					`AI failed playing card with id ${cardId}, removing.`
				);

				controller_card.removeCard(aiState, cardId);
			}
		}
	}

	playCardFromHand = async (gameManager: GameManager, cardId: number) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const card = controller_card.getCurrCard(cardId);

		let cardCost = 0;

		if (card != null && card.cost != null) {
			if (card.type === 'Award' || card.type === 'Contract') {
				cardCost = 0;
			} else {
				cardCost = card.cost as number;
			}
		}

		const paymentObject = await ai_purchase.createPaymentObjectForCost(
			aiState,
			cardCost
		);

		// await getPaymentObjectForCardId()
		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			cardId: cardId,
			paymentObject,
		};

		if (!paymentObject.paymentPossible) {
			return;
		}

		await controller_game.playCard(botPlayerData, gameManager);
		// controller_card.removeCard(aiState, cardId);
		// deleteCardChance(aiState, cardId); //SHOULD always be removed since it's in the playCard logic...

		if (gameState.turnType === decisionCardResolution) {
			ai_decision.chooseCardResolution(gameManager);
		}
	};

	playAllContractsAndAwards = async (gameManager: GameManager) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		const skip = true;

		if (skip) {
			return;
		}
		const currentPlayableCardIds = [
			// ss awards
			0, 1, 2, 3, 4, 5, 6,

			// fw awards
			100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
			113, 114, 115, 116,
		];

		for (let i = 0; i < aiState.seasonalCards.length; i++) {
			const currCardId = aiState.seasonalCards[i];
			if (currentPlayableCardIds.includes(currCardId)) {
				console.log(
					`AI with id ${activePlayerId} playing card with id ${currCardId}`
				);
				await this.playCardFromHand(gameManager, currCardId);
			}
		}
	};

	playHand = async (gameManager: GameManager) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		// await this.playAllContractsAndAwards(gameManager);

		if (aiState.seasonalCards.length <= 0) return;
		for (let i = 0; i < aiState.seasonalCards.length; i++) {
			if (coinFlip(1 / aiState.seasonalCards.length)) {
				// odds are we will play 1 card a turn
				console.log('AI playing card');
				const cardId = aiState.seasonalCards[i];
				if (cardId >= 0) {
					await this.playCardFromHand(gameManager, cardId);
				}
			}
		}
	};

	playEquipmentOnTable = async (gameManager: GameManager) => {
		const { gameState } = gameManager;
		const activePlayerId = gameState.activePlayerId;
		const aiState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		for (let i = 0; i < aiState.equipment.length; i++) {
			if (coinFlip(1 / aiState.equipment.length)) {
				// odds are we will play 1 card a turn
				console.log('AI playing card');
				const cardId = aiState.equipment[i];
				await this.playEquipmentOnTableById(gameManager, cardId);
			}
		}
	};

	playEquipmentOnTableById = async (
		gameManager: GameManager,
		cardId: number
	) => {
		const { gameState } = gameManager;

		const botPlayerData = {
			playerId: gameState.activePlayerId,
			gameId: gameState.game_id_server,
			cardId: cardId,
		};

		await controller_game.playEquipmentById(botPlayerData, gameManager);
		// controller_card.removeCard(aiState, cardId);
		// deleteCardChance(aiState, cardId); //SHOULD always be removed since it's in the playCard logic...

		if (gameState.turnType === decisionCardResolution) {
			ai_decision.chooseCardResolution(gameManager);
		}
	};
}

export const ai_seasonal = new AI_Seasonal();
